<div class="relative text-error">
  <div class="absolute animate-ping opacity-75">
    <market-icon iconName="zap"></market-icon>
  </div>
  <div class="relative">
    <market-icon iconName="zap"></market-icon>
  </div>
</div>
